// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var ToolbarItemVue2 = {
  name: 'KendoToolbarItem',
  methods: {
    element: function element() {
      return this.$el;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", {
      "class": 'k-toolbar-item'
    }, [defaultSlot]);
  }
};
/**
 * Represents the [Kendo UI for Vue ToolbarItem component]({% slug overview_toolbar %}).  A container component for the sub-elements of the Toolbar.
 *
 *  ```jsx
 *  <template>
 *    <Toolbar>
 *      <ButtonGroup>
 *        <Button :icon="'bold'" :title="'Bold'" :togglable="true" />
 *        <Button :icon="'italic'" :title="'Italic'" :togglable="true" />
 *        <Button :icon="'underline'" :title="'Underline'" :togglable="true" />
 *      </ButtonGroup>
 *      <ToolbarSpacer />
 *      <SplitButton :text="'Insert'" :items="splitItems"> </SplitButton>
 *      <ToolbarSeparator />
 *      <Button :icon="'cut'" :title="'Cut'"> Cut </Button>
 *  </Toolbar>
 *  </template>
 *  ```
 */
var ToolbarItem = ToolbarItemVue2;
export { ToolbarItem, ToolbarItemVue2 };